import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

export type GetOemServiceParams = {
  id: number;
};

export type GetOemServiceResponse = APIResponse<{
  oemServiceName: string;
  imageUrl: string;
  iconUrl: string;
  keyColor: string;
  serviceUrl: string;
  favoriteUpperLimit: number;
  favoriteUndeleteableDays: number;
  serviceKey: string;
  oemServiceBranches: {
    oemServiceBranchName: string;
    imageUrl: string;
    iconUrl: string;
    keyColor: string;
    branchUrl: string;
    branchKey: string;
    defaultFlag: boolean;
  }[];
}>;

export const getOemService = async (params: GetOemServiceParams) => {
  return await http<GetOemServiceResponse>(`/user/v1/oem-service/${params.id}`, {
    method: 'GET',
  });
};
